import { Choice } from '../models/choice';

export const freightClasses: Choice[] = [
    { value: '50', label: '50' },
    { value: '55', label: '55' },
    { value: '60', label: '60' },
    { value: '65', label: '65' },
    { value: '70', label: '70' },
    { value: '77.5', label: '77.5' },
    { value: '85', label: '85' },
    { value: '92.5', label: '92.5' },
    { value: '100', label: '100' },
    { value: '110', label: '110' },
    { value: '125', label: '125' },
    { value: '150', label: '150' },
    { value: '175', label: '175' },
    { value: '200', label: '200' },
    { value: '250', label: '250' },
    { value: '300', label: '300' },
    { value: '400', label: '400' },
    { value: '500', label: '500' }
];
